(() => {
  if (window.UpQuantityDiscountsInitialized) return;
  window.UpQuantityDiscountsInitialized = true;

  const updateCards = (root, quantity) => {
    root.querySelectorAll('[data-quantity-discount-option]').forEach((card) => {
      const selected = Number(card.dataset.quantity) === Number(quantity);
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  };

  const setQuantity = (root, quantity) => {
    const inputId = root.dataset.quantityInput;
    const input = inputId ? document.getElementById(inputId) : null;
    if (!input) return;

    const min = Number(input.min || input.dataset.min || 1);
    const max = input.max ? Number(input.max) : null;
    const step = Number(input.step || 1);
    let nextQuantity = Math.max(min, Number(quantity));

    if (max !== null && Number.isFinite(max)) nextQuantity = Math.min(max, nextQuantity);
    if (step > 1) nextQuantity = min + Math.round((nextQuantity - min) / step) * step;

    input.value = String(nextQuantity);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    updateCards(root, nextQuantity);
  };

  document.addEventListener('click', (event) => {
    const card = event.target.closest('[data-quantity-discount-option]');
    if (!card || card.disabled) return;
    const root = card.closest('[data-up-quantity-discounts]');
    if (!root) return;
    setQuantity(root, card.dataset.quantity);
  });

  document.addEventListener('input', (event) => {
    const input = event.target.closest('.up-product-quantity .quantity__input');
    if (!input) return;
    const quantityBlock = input.closest('.up-product-quantity');
    const root = quantityBlock?.querySelector('[data-up-quantity-discounts]');
    if (root) updateCards(root, input.value);
  });

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-up-quantity-discounts]').forEach((root) => {
      const selected = root.querySelector('[data-quantity-discount-option].is-selected:not(:disabled)')
        || root.querySelector('[data-quantity-discount-option]:not(:disabled)');
      if (selected) setQuantity(root, selected.dataset.quantity);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
